<template>
	<div class="back">
		<!-- 新增一个 flex 容器 -->
		<div class="login-wrapper">
			<div class="logo">
				<i class="el-icon-s-home"></i>
				Homie双涵公寓智能管理平台 v4.0
			</div>

			<div class="login">
				<h1 class="loginh1" style="margin: 1rem auto; color: #5E6E8E;">管理员登录</h1>
				<el-divider></el-divider>

				<el-form :model="ruleForm" label-position="left" label-width="42px" status-icon :rules="rules" ref="ruleForm">
					<el-form-item prop="account">
						<template slot="label">
							<div class="label_1">
								<i class="el-icon-s-custom" style="font-size: 1.5rem;color: #fff;"></i>
							</div>
						</template>
						<el-input class="account" v-model="ruleForm.account" autocomplete="off" placeholder="请输入账号"></el-input>
					</el-form-item>

					<el-form-item prop="password">
						<template slot="label">
							<div class="label_2">
								<i class="el-icon-lock" style="font-size: 1.5rem;color: #fff;"></i>
							</div>
						</template>
						<el-input class="password" v-model="ruleForm.password" autocomplete="off" placeholder="请输入密码" show-password
							@keyup.enter.native="submitForm('ruleForm')"></el-input>
					</el-form-item>

					<el-form-item prop="code" style="width: 100%;">
						<div class="code_class">
							<el-input class="code" v-model="ruleForm.code" autocomplete="off" placeholder="请输入验证码"
								@keyup.enter.native="submitForm('ruleForm')" style="margin-right: 1.5rem;"></el-input>
							<img :src="captchaUrl" alt="" @click="GETverify" style="width:7.5rem;">
						</div>
					</el-form-item>

					<el-button class="login_button" type="primary" @click="submitForm('ruleForm')">登录</el-button>
				</el-form>
			</div>
		</div>

		<img src="../../assets/loginbj.png" class="back_img" />
	</div>
</template>

<script>
	import {
		login,
		verify
	} from "@/api/api.js"
	import {
		BASEURL
	} from "@/Utils/request.js";
	export default {
		data() {
			var validatePassword = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					callback();
				}
			};
			var validateaccount = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入用户名'));
				} else {
					callback();
				}

			};
			var validatecode = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入验证码'));
				} else {
					callback();
				}
			};

			return {
				ruleForm: {
					account: '',
					password: '',
					code: ''
				},
				rules: {
					account: [{
						validator: validateaccount,
						trigger: 'blur'
					}],
					password: [{
						validator: validatePassword,
						trigger: 'blur'
					}],
					code: [{
						validator: validatecode,
						trigger: 'blur'
					}]
				},
				captchaUrl: `${BASEURL}admin/verify`
			}
		},
		methods: {
			submitForm(formName) {
				this.$refs['ruleForm'].validate(async valid => {
					if (valid) {
						let res = await login(this.ruleForm)
						const {
							status,
							data,
							msg
						} = res
						if (status == 200) {
							this.$message.success('欢迎回来Homie双涵公寓v4.0！')
							this.$store.commit('setUserToken', data.token)
							sessionStorage.setItem('token', data.token)
							this.$router.push('/home')
						} else {
							this.$message.error(res.msg);
						}
					} else {
						return false
					}
				})
			},
			GETverify() {
				verify().then(blob => {
					const imageUrl = URL.createObjectURL(blob);
					this.captchaUrl = imageUrl
				})
			}
		},
		mounted() {
			this.GETverify()
		}
	}
</script>

<style scoped>
	.back {
		height: 100vh;
		width: 100vw;
		/* background-color: #f1f3f4; */
		overflow-x: hidden;
		overflow-y: hidden;
	}

	.login {
		width: 18%;
		background-color: #fff;
		padding: 1.875rem;
		position: absolute;
		left: 75%;
		top: 50%;
		transform: translate(-50%, -50%);
		border-radius: 25px;
		display: flex;
		flex-direction: column;
	}

	.logo {
		position: absolute;
		color: #fff;
		font-size: 1.75rem;
		font-weight: bold;
		margin: 2.5rem;
	}

	.login_button {
		font-weight: bold;
		font-size: 1.125rem;
		margin: 0 auto;
		width: 100%;
		border: #4E67FF;
		background-color: #4E67FF;
	}

	.login_button:hover {
		transform: scale(1.01);
		transition: 0.5s;
	}

	>>>.el-input__inner {
		border-radius: 0 4px 4px 0px;
		height: 42px;
	}

	.account>>>.el-input__inner:hover {
		border-color: #4E67FF;
	}

	.password>>>.el-input__inner:hover {
		border-color: #A2AFFF;
	}

	.account>>>.el-input__inner:focus {
		border-color: #4E67FF;
		box-shadow: none;
		transition-duration: .5s;
	}

	.password>>>.el-input__inner:focus {
		border-color: #A2AFFF;
		box-shadow: none;
		transition-duration: .5s;
	}

	.code>>>.el-input__inner:focus {
		border-color: #DFE2E8;
		box-shadow: none;
		transition-duration: .5s;
	}

	.el-form-item__content {
		margin-left: 80px !important;
		width: 100% !important;
	}

	.label_1 {
		background-color: #4E67FF;
		width: 42px;
		height: 42px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px 0 0 4px;
	}

	.label_2 {
		background-color: #A2AFFF;
		width: 42px;
		height: 42px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px 0 0 4px;
	}

	.code_class {
		display: flex;
		margin-left: -42px;
		justify-content: space-between;
	}

	.back_img {
		height: 100%;
		width: 100%;
		z-index: -1;
	}

	@media (max-width: 1030px),
	(max-device-width: 1030px) {
		.back {
			height: 100vh;
			width: 100vw;
			position: relative;
		}

		>>>.el-form-item__error {
			display: none !important;
		}

		.logo {
			position: fixed;
			top: 0rem;
			right: 0rem;
		}

		.login {
			width: 70%;
			padding: 2rem;
			position: fixed;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			background-color: rgba(255, 255, 255, 0.5);
		}

		.login {
			width: 80%;
			max-width: 400px;
			background-color: rgba(255, 255, 255, 0.9);
			padding: 1.875rem;
			border-radius: 25px;
			box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
			z-index: 10;
		}

		.login-wrapper {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			min-height: 100vh;
			background: url('../../assets/loginbj2.png') no-repeat center center fixed;
		}

		.back_img {
			display: none;
		}


	}

	@media (max-width: 1030px) and (orientation: landscape) {
		.login {
			width: 20rem;
			height: 24rem;
			padding: 2rem;
			position: fixed;
			top: 50%;
			left: 76%;
			transform: translate(-50%, -50%);
			background-color: rgba(255, 255, 255, 0.5);
		}

		.logo {
			position: fixed;
			right: unset;

		}

		.login-wrapper {
			display: block;

		}

		.loginh1 {
			margin-bottom: 1rem !important;
			margin-top: 0rem !important;
		}

		.el-divider {
			margin: 1rem;
		}

		.label_1 {
			height: 3rem;
		}

		.label_2 {
			height: 3rem;
		}

		>>>.el-form-item {
			display: flex;
			align-items: center;
			margin-bottom: 0rem;
		}

		>>>.el-form-item__content {
			margin-left: 0 !important;
		}

		>>>.el-input__inner {
			border-radius: 0 4px 4px 0px;
			height: 3rem;
		}

		.code_class {
			flex-wrap: wrap;
			margin-top: 0px;
			margin-left: 0;
		}

		.code_class>>>img {
			width: 100% !important;
			margin-top: 0.24rem;
			margin-bottom: 1rem;
		}

		.code {
			margin-right: 0 !important
		}

		.back_img {
			display: none;
		}
	}
</style>